import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { Photo } from './Photo';
import { useContext } from 'react';
import { ToolContext } from '../../../core/context/ToolContext';

import { makeStyles } from '@mui/styles'
import { UsageOverView } from '../toolUsage/usageOverview/UsageOverview';
import { UsageIcons } from '../toolUsage/global/Icons';

const textStyle = makeStyles(theme => ({
    default:{
        height:'44px',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        gap:'8px',
        color:'#292C2F',
        borderRadius:'6px',
        '&:hover': {
            backgroundColor:'#FFFFFF',
        },
    },
    active:{
        backgroundColor:'#FFFFFF',
        boxShadow: '0px 2px 4px 0px #00000014',
    },
}));


const Profile = () => {
    const classes = textStyle()
    const {tool_state, tool_category_state, profile_state, subdivision_state} = useContext(ToolContext)
    const __LOCATION = useLocation().pathname


    const urlParams = new URLSearchParams(window.location.search);
    const nav = useHistory()
    useEffect(() => {
        if (!urlParams.get('tabs')) {
            nav.push(`${__LOCATION}?tabs=usage-overview`)
        }
        // eslint-disable-next-line
    },[])

    const handleClickTabs = (value) => {
        nav.push(`${__LOCATION}?tabs=${value}`)
    }
    
    return (
        <Box width="100%" height="100%">
            <Photo tool_state={tool_state} profile_state={profile_state}/>
            <Container>
                <Box width="578px" height="auto" display="flex" alignItems="center" gap="2px" p="4px"  bgcolor="#F7F8F8" borderRadius="8px">
                    {/* <Button sx={{width:'224px'}} onClick={()=>handleClickTabs('empinfo')} className={`${classes.default} ${urlParams.get('tabs') === 'empinfo' && classes.active}`}>
                        <EmployeeIcons/>
                        <Typography >
                            Employee Information
                        </Typography>
                    </Button> */}
                    <Button sx={{width:'189px'}} onClick={()=>handleClickTabs('usage-overview')} className={`${classes.default} ${urlParams.get('tabs') === 'usage-overview' && classes.active}`}>
                        <UsageIcons/>
                        <Typography >
                            Usage Overview
                        </Typography>
                    </Button>
                    {/* <Button sx={{width:'155px'}} onClick={()=>handleClickTabs('daily-task')} className={`${classes.default} ${urlParams.get('tabs') === 'daily-task' && classes.active}`}>
                        <DailyTasksIcons/>
                        <Typography >
                            Daily Tasks
                        </Typography>
                    </Button> */}
                </Box>
            </Container>
            <Components urlParams={urlParams} tool_state={tool_state} subdivision_state={subdivision_state} tool_category_state={tool_category_state} __LOCATION={__LOCATION}/>
        </Box>
    )
}

const Components = ({urlParams, tool_state, subdivision_state, tool_category_state, __LOCATION}) => {
    if (urlParams.get('tabs') === 'usage-overview' || !urlParams.get('tabs')  ) {
        return <UsageOverView/>
    }
}

export default Profile;